var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOpened = function SvgEyeOpened(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 13,
    viewBox: "0 0 19 13"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13C4.26 13 0 8.125 0 6.5S4.26 0 9.5 0 19 4.875 19 6.5 14.74 13 9.5 13zM1 6.5c.082.86 3.76 5.5 8.5 5.5s8.418-4.64 8.5-5.5C17.918 5.64 14.24 1 9.5 1S1.082 5.64 1 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 7.25c-1.05 0-1.875-.825-1.875-1.875 0-.9.6-1.575 1.425-1.8C9.95 3.5 9.725 3.5 9.5 3.5c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3c0-.225 0-.45-.075-.675-.225.825-.9 1.425-1.8 1.425z"
  }))));
};
export default SvgEyeOpened;